<div class="modal-header">
  <h4 class="modal-title">
    👉 Confirm: ₹{{ this.orderData?.totals?.amount }} Payment Received?
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>
<form [formGroup]="dispatchForm" (ngSubmit)="onSubmit()">
  <div class="modal-body">
    <div class="row g-2 mb-3 mt-2 align-items-center justify-content-between">
      <div class="col-lg-12 mb-3">
        <label class="form-label text-body1 d-block">Received Payment *</label>
        <input
          type="number"
          class="form-control text-body1"
          placeholder="Enter Received PAYMENT"
          formControlName="amount"
          min="0"
        />
      </div>
      <div class="col-lg-12 mb-3">
        <label class="form-label text-body1 d-block">Different amount</label>
        <input
          type="number"
          class="form-control text-body1"
          placeholder="Enter Different"
          formControlName="amountDiff"
          min="0"
        />
      </div>
      <div class="col-lg-12 mb-3">
        <label class="form-label text-body1 d-block">Notes</label>
        <input
          type="text"
          class="form-control text-body1"
          placeholder="Enter Note"
          formControlName="notes"
        />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="d-flex align-items-center justify-content-END w-100">
      <button
        [disabled]="dispatchForm.invalid"
        class="btn btn-primary"
        type="submit"
      >
        Order Paid
      </button>
    </div>
  </div>
</form>
